import { Component, inject, model } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogActions, MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Genre } from '@shared/interfacres/genre';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-edit-genre-dialog',
  templateUrl: 'edit-genre-dialog.html',
  styleUrl: './edit-genre-dialog.scss',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
  ],
})
export class EditGenreDialog {
  readonly dialogRef = inject(MatDialogRef<EditGenreDialog>);
  readonly data = inject<Genre>(MAT_DIALOG_DATA);
  readonly genreName = model('');

  constructor() {
    if (this.data?.name)
    this.genreName.set(this.data.name);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
